// Combined: all.js holds the bulk, individual files override per-tool
import all from './all'

const ctx = require.context('.', false, /\.js$/)
const tools = { ...all }
ctx.keys().forEach(key => {
  if (key === './index.js' || key === './all.js') return
  const name = key.replace(/^\.\//, '').replace(/\.js$/, '')
  tools[name] = { ...tools[name], ...ctx(key).default }
})
export default tools
